export default __webpack_public_path__ + "static/media/reading-level-icon.05ab3070.png";